export default "__VITE_ASSET__UMLZExFg__"